import { Inject, Injectable, DOCUMENT } from '@angular/core'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'

/**
 *
 * This service is used to initialize Microsoft Clarity for tracking user interactions
 * and behavior on the website. It is injected with the application configuration
 * to get the Microsoft Clarity project ID.
 *
 * https://clarity.microsoft.com/
 *
 * you must be clarity admin to login on the dashboard and check the data.
 */
@Injectable({
  providedIn: 'root',
})
export class GbMicrosoftClarityService {
  constructor(
    @Inject(DOCUMENT) protected document: Document,
    @Inject(APP_CONFIG) protected appConfig: any,
  ) {}

  initClarity() {
    const clarityScript = `
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${this.appConfig.microsoftClarityProjectId}");
    `

    const script = this.document.createElement('script')

    script.text = clarityScript
    this.document.head.appendChild(script)
  }
}
